module.exports = __webpack_public_path__ + "static/media/11b_hero_tablet.bf7dc440.jpg";